import React from 'react';
import { Box, Modal } from '@drone-js/core';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

interface OfferCardDetailModalProps {
    modalVisible: boolean;
    onCloseModal: () => void;
    children: React.ReactNode;
}

const OfferCardDetailModal: React.FC<OfferCardDetailModalProps> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);

    return (
        // We need zIndex to override DroneJS hardcoded zIndex component in outer level layout
        <Modal size="m" visible={props.modalVisible} onClose={props.onCloseModal} zIndex={1020} data-testid="available-option-card-modal" title={cms[288251]}>
            <Box display="flex" flexDirection="column" gap="16">
                {props.children}
            </Box>
        </Modal>
    );
};

OfferCardDetailModal.displayName = 'OfferCardDetailModal';
export default OfferCardDetailModal;
